import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { FinanceService } from '../services/finance.service';

@Component({
  selector: '',
  template: '',
})
export class BalanceDetailsSearchHandler extends BaseSearchComponent<FinanceService> implements OnInit {
  public searchName: string;
  isAdvanceSearchDisplayed: boolean;
  //

  searchCriteriaData: any;

  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.addLink = '/search-balance-details';
    //this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchName = 'SearchBalanceDetails';

    let agentId = this.route.snapshot.paramMap.get('agentId');

    if (agentId != undefined && agentId != null) {
      this.searchName = 'SearchTeamBalanceDetails';
      this.searchCriteriaData = { 'AgentBalanceDetailDO.agentId': agentId };
    }
    //this.service.forAuditSearchList = false;
    //this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'BalanceDetails',
        link: '/search-balance-details',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Edit',
        link: '/search-balance-details',
      },
      {
        id: 'Delete',
        link: '/search-balance-details',
      },
      {
        id: 'Audit',
        link: '/search-balance-details',
      },
      {
        id: 'Close',
        link: '/search-balance-details',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Balance Details';
    header.title = this.settingService.getLabelValue('BalanceDetails');
    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }
}
